import React from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { Device } from '../../../DeviceUtils/DeviceUtils';

const defaultStyles = StyleSheet.create({
    iconContainer: {
        alignSelf: 'stretch',
        alignItems: 'flex-end',
        marginTop: Device.isAndroid ? 10 : 40,
        paddingHorizontal: 17
        // it's break a close button in the modal
        // position: 'absolute',
        // zIndex: 5,
        // right: 0
    },
    iconClose: {
        width: 31,
        height: 31
    }
});

if (Device.isWeb) {
    defaultStyles.iconContainer = {
        position: 'absolute',
        // top: 44,
        right: 44,
        width: 31,
        height: 31,
        top: 10
    };
}

const ModalHeader = ({ style, iconName, onPress }) => (
    <View
        style={[
            defaultStyles.iconContainer,
            style.iconContainer,
            Device.isWeb && { zIndex: 99999 }
        ]}
    >
        <Icon
            name={iconName}
            style={[defaultStyles.iconClose, style.iconClose]}
            testID="close_button"
            onPress={onPress}
        />
    </View>
);

ModalHeader.defaultProps = {
    style: {},
    iconName: 'close'
};

ModalHeader.propTypes = {
    style: PropTypes.shape({}),
    iconName: PropTypes.string,
    onPress: PropTypes.func.isRequired
};

export default ModalHeader;
